import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a trash icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/trash?f=classic&s=solid
 */
export function TrashIcon(props: CustomIconProps) {
  return <Icon icon={faTrash} {...props} />;
}
